import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../ui/tooltip';
import { Timestamp } from '../../../ui/timestamp';

interface TaxonomyVersionBadgeProps {
  version?: string;
  classifiedAt?: string;
}

const TaxonomyVersionBadge: React.FC<TaxonomyVersionBadgeProps> = ({ version, classifiedAt }) => {
  if (!version) return null;

  const badge = (
    <div className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 text-[10px] font-medium text-gray-600 cursor-help">
      v{version}
    </div>
  );

  if (!classifiedAt) {
    return badge;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent>
        <div className="text-xs">
          <div>Taxonomy {version}</div>
          <div>
            Classified <Timestamp value={classifiedAt} format="absolute" hideTooltip />
          </div>
          <div>
            (<Timestamp value={classifiedAt} format="relative" hideTooltip />)
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default TaxonomyVersionBadge;
